import React from 'react'
import Bg from "../assets/hand-mockup.png"
import { useTranslation } from 'react-i18next'

const HomepageAboutUs = () => {
    const { t } = useTranslation();

    return (
        <div className='homepage-about-us-content'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 text-center">
                        <img src={Bg} alt="" width="425px" />
                    </div>
                    <div className="col-lg-7">
                        <h3 className='mt-lg-0 mt-5'>
                            {t('Yatırımınızı Güçlendirin, Paragon ile Geleceğe Yatırım Yapın')}
                        </h3>
                        <div>
                            <div className='row mt-5'>
                                <div className="col-lg-1 col-2">
                                    <div className='icon-background'>
                                        <i className="fa-solid fa-circle fa-xs"></i>
                                    </div>
                                </div>
                                <div className="col-lg-11 col-10">
                                    <div>
                                        <h5>{t('Piyasaya Hızlı Giriş')}</h5>
                                        <p className="mb-0">
                                            {t('Paragon Yatırım, kullanıcı dostu platformları ve hızlı işlem seçenekleriyle forex piyasasına kolay giriş imkânı sunar. Hem yeni başlayanlar hem de deneyimli yatırımcılar için ideal çözümler sağlar.')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-5'>
                                <div className="col-lg-1 col-2">
                                    <div className='icon-background'>
                                        <i className="fa-solid fa-circle fa-xs"></i>
                                    </div>
                                </div>
                                <div className="col-lg-11 col-10">
                                    <div>
                                        <h5>{t('Yatırım Ürünleri')}</h5>
                                        <p className="mb-0">
                                            {t('Paragon, farklı risk profillerine ve yatırım hedeflerine uygun geniş bir ürün yelpazesi sunar. Forex, hisse senetleri, emtialar ve daha fazlası ile yatırımcılarına çeşitli seçenekler ve hesap türleriyle esneklik sağlar.')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-5'>
                                <div className="col-lg-1 col-2">
                                    <div className='icon-background'>
                                        <i className="fa-solid fa-circle fa-xs"></i>
                                    </div>
                                </div>
                                <div className="col-lg-11 col-10">
                                    <div>
                                        <h5>{t('Başarı Oranı')}</h5>
                                        <p className="mb-0">
                                            {t('Paragon Yatırım, %85 başarı oranıyla yatırımcılarına güvenli ve kazançlı bir yol sunar. Profesyonel analizler ve güçlü ticaret araçları ile siz de bu başarı hikâyesinin bir parçası olun.')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomepageAboutUs